import { useMemo } from 'react';
import { UserAvatar } from '@/app/components/shared/UserAvatar';
import { useGoToProfile } from '@/app/hooks';
import { cn } from '@/app/utils';
import { isAsciiStr } from '../utils';

interface CreateByProps {
  className?: string;
  isSubmitSuccess: boolean;
  creator?: {
    id?: string;
    avatar?: string;
    nick_name?: string;
  };
}

export const CreateBy = ({ className, isSubmitSuccess, creator }: CreateByProps) => {
  const { goToProfile } = useGoToProfile();

  const scaleName = useMemo(() => {
    return !creator?.avatar && !isAsciiStr(creator?.nick_name?.slice(0, 2) ?? '');
  }, [creator?.avatar, creator?.nick_name]);

  if (!isSubmitSuccess) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex min-h-[25px] cursor-pointer items-center justify-center gap-2 rounded-full bg-system-white08 p-1 pr-3',
        className,
      )}
      onClick={() => goToProfile(creator?.id)}
    >
      <UserAvatar
        userInfo={{
          id: creator?.id || '',
          avatar: creator?.avatar || '',
          nickname: creator?.nick_name || '',
          role: 'user',
          gender: 'unspecified',
          created_at: '',
        }}
        className="size-4 flex-shrink-0 object-cover text-xs"
        nameClassName={scaleName ? 'scale-75' : undefined}
      />
      <span className="line-clamp-1 text-system-white text-xs">{creator?.nick_name}</span>
    </div>
  );
};
